import { extendTheme } from '@chakra-ui/react';
import '@fontsource-variable/sora'

const colors = {
  "black": "#0c1015",
  "gray": {
    "50": "#f9fafa",
    "100": "#f1f1f2",
    "200": "#e6e7e9",
    "300": "#d2d4d7",
    "400": "#a9adb2",
    "500": "#797f88",
    "600": "#4d5560",
    "700": "#2e3744",
    "800": "#19202b",
    "900": "#141a23"
  },
  "yellow": {
    "50": "#fefefd",
    "100": "#f9f9f5",
    "200": "#efede1",
    "300": "#e3e0ca",
    "400": "#d2cdaa",
    "500": "#b2a96e",
    "600": "#92873f",
    "700": "#726931",
    "800": "#554f25",
    "900": "#46411e"
  },
  "green": {
    "50": "#f9fcfb",
    "100": "#dfeee7",
    "200": "#bedcce",
    "300": "#99c9b2",
    "400": "#72b495",
    "500": "#499e77",
    "600": "#398461",
    "700": "#2c664b",
    "800": "#24543e",
    "900": "#1e4533"
  },
  "teal": {
    "50": "#f7fafb",
    "100": "#dbebec",
    "200": "#bcdadc",
    "300": "#97c6c8",
    "400": "#68acaf",
    "500": "#429598",
    "600": "#35797b",
    "700": "#295e60",
    "800": "#234e50",
    "900": "#1c4042"
  },
  "cyan": {
    "50": "#f7fafb",
    "100": "#dfebee",
    "200": "#d1e2e7",
    "300": "#c2d8de",
    "400": "#93bbc6",
    "500": "#7daeba",
    "600": "#649ead",
    "700": "#418496",
    "800": "#356d7b",
    "900": "#29545f"
  },
  "blue": {
    "50": "#f4f6f9",
    "100": "#d6dfe9",
    "200": "#b8c7d9",
    "300": "#97aec8",
    "400": "#7996b8",
    "500": "#5e81aa",
    "600": "#436c9b",
    "700": "#335377",
    "800": "#2a4461",
    "900": "#22374f"
  },
  "purple": {
    "50": "#f8f6fa",
    "100": "#e2dcec",
    "200": "#cdc3df",
    "300": "#ae9ecb",
    "400": "#9a85be",
    "500": "#7f64ad",
    "600": "#6d4fa1",
    "700": "#5a3d8e",
    "800": "#4a3274",
    "900": "#372555"
  },
  "pink": {
    "50": "#faf6f8",
    "100": "#eddde4",
    "200": "#dec1cf",
    "300": "#cb9db3",
    "400": "#be849f",
    "500": "#ac6486",
    "600": "#a04d74",
    "700": "#873b5e",
    "800": "#692e49",
    "900": "#4d2136"
  },
  "red": {
    "50": "#faf6f6",
    "100": "#ecdddc",
    "200": "#dcbfbe",
    "300": "#c99b99",
    "400": "#be8684",
    "500": "#af6a68",
    "600": "#a1524f",
    "700": "#883d3b",
    "800": "#733432",
    "900": "#532624"
  },
  "orange": {
    "50": "#fcfaf9",
    "100": "#f2ece6",
    "200": "#e3d7c9",
    "300": "#cdb9a1",
    "400": "#ba9d7d",
    "500": "#a9855d",
    "600": "#966e41",
    "700": "#775833",
    "800": "#5e4528",
    "900": "#4d3921"
  },
  "primary": {
    "50": "#f9f7f3",
    "100": "#e6e0d0",
    "200": "#d1c5a8",
    "300": "#b7a477",
    "400": "#a8925c",
    "500": "#937a3f",
    "600": "#7c6735",
    "700": "#63532b",
    "800": "#544624",
    "900": "#3c321a"
  }
}

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    cssVarPrefix: 'App',
  },
  colors,
  fonts: {
    heading: "'Sora Variable', sans-serif",
    body: "'Sora Variable', sans-serif",
  },
  styles: {
    global: {
      // styles for the `body`
      body: {
        color: 'gray.800',
        fontSize: 'sm',
        fontWeight: '400',
      },
      
    }
  },
  components: {
    Heading: {
      baseStyle: {
        color: 'gray.700',
      },
    },
    Button: {
      defaultProps: {
        colorScheme: 'primary',
        variant: 'solid'
      },
    },
    Input: {
      defaultProps: {
        focusBorderColor: 'primary.500',
      },
    }
  }
});

export default theme;